<!--
Author: TangChen
Date: 2018-09-05
Desc: 登录后页面组件，由router.js 配置引入
-->
<template>
    <div class="view-frame view">
        <header-com />
        <el-container class="home-box">
            <el-main>
                <router-view :key="$route.name" />
                <log />
            </el-main>
        </el-container>
        <!--<footer-com style="visibility: hidden;" />-->
        <footer-com />
    </div>
</template>
<script>
import headerCom from "@/components/layout/header.vue";
import footerCom from "@/components/layout/footer.vue";
import log from "@/components/misc/log.vue";
export default {
    components: {
        headerCom,
        footerCom,
        log
    },
    data () {
        return {
            url: ""
        };
    },
    mounted(){
    },
    methods: {
    }
};
</script>
<style lang="scss">
.view-frame {
  min-height: 500px;
  .home-box {
    width: 1200px;
    margin: 10px auto 0;
    .menu-nav {
      overflow: hidden;
      margin-right: 14px;
    }
    .el-main {
      min-height: 400px;
      padding: 0;
      .bizcomp:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>
